import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteAllOrgStructureAssignments as apiFn } from "../../api/apiOrgStructureAssignments";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useDeleteAllOrgStructureAssignments() {
    const qc = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: deleteAllAssignments, isPending: isDelete } = useMutation({
        mutationFn: (req) => apiFn(req),
        onSuccess: (r) => {
            enqueueSnackbar(r.message, { variant: "success" });
            qc.invalidateQueries({ queryKey: ["orgStructureAssignments"] });
        },
        onError: (err) => {
            enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" });
        },
    });

    return { deleteAllAssignments, isDelete };
}
